export default __webpack_public_path__ + "static/media/event_join.3a56a38c.svg";